module.exports = __webpack_public_path__ + "static/media/premium-pantry.fcb49fde.png";